import * as React from 'react';
import FormControl from "@mui/material/FormControl";
// import {Tooltip} from "@mui/material/Tooltip";
import {InputLabel, Select, TextField} from "@mui/material";
import {NumericFormat} from "react-number-format";
import {useEffect, useState} from "react";
import {getAllProfiles} from "../ExternalData/Profile/ProfileClient";
import {getAllProducts, getProductListEnhanced} from "../ExternalData/Product/ProductClient";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import Box from '@mui/material/Box';
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeContractDataPointValue} from "../ContractDataPointValue/contractDataPointValueSlice";
import {changeContractSectionFilter} from "../ContractSectionFilter/contractSectionFilterSlice";
import {changeContractDrilldownCDPVF} from "../ContractDrilldown/ContractDrilldownCDPVF/contractDrilldownSliceCDPVF";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import Tooltip from "@mui/material/Tooltip";
import {Autocomplete} from "@mui/lab";
import {changeWorkQueue} from "../WorkQueue/workQueueSlice";
import {getDataPointXrefByDataPointId} from "../DataPointXref/DataPointXrefClient";
import {changeHelper} from "../ContractDrilldown/ContractDrilldownCS/Helpers/helperSlice";
import {getAttributesEnhanced} from "../DataPointAttribute/DataPointAttributeClient";
import {Controller} from "react-hook-form";
import FormDatePicker from "./FormDatePicker";


function DynamicDatePicker({
                               selectorLabel,
                               selectorValue,
                               handleValueChange,
                               autoFocus,
                               disabled,
                           }) {
    return (
        <FormControl sx={{ width: 150 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={selectorLabel}

                    value={
                        selectorValue
                            ? dayjs(selectorValue)
                            : null
                    }

                    onChange={(newValue) => {
                        handleValueChange(
                            newValue && newValue.isValid()
                                ? newValue.format("YYYY-MM-DD")
                                : null
                        );
                    }}

                    format="YYYY-MM-DD"

                    disabled={disabled}

                    slotProps={{
                        textField: {
                            variant: "standard",
                            autoFocus,
                            sx: {
                                width: 150
                            },
                            InputLabelProps: {
                                shrink: true,
                            },
                        }
                    }}
                />
            </LocalizationProvider>
        </FormControl>
    );
}


// export default function DynamicCdpvValueField({selectorDataPointId, selectorValue, selectorDataType, selectorContext, selectorLabel,
//                                                   fieldName = null, setValue = null,        autoFocus = false, disabled = false,     onChange }) {

    export default function DynamicCdpvValueField({
                                                      selectorDataPointId,
                                                      selectorValue,
                                                      selectorDataType,
                                                      selectorContext,
                                                      selectorLabel,
                                                      fieldName = null,
                                                      setValue = null,
                                                      control = null,
                                                      autoFocus = false,
                                                      disabled = false,
                                                      onChange
                                                  }) {
    // export default function DynamicCdpvValueField(props) {


    const dispatchData = useDispatch() ;


    const [productDropdown, setProductDropdown] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [useCode, setUseCode] = useState(null);

    const [attributesDropdown, setAttributesDropdown] = useState([]);
    const [profileDropdown, setProfileDropdown] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);

    const [dpvItems, setDpvItems] = useState([]);
    const [filteredDPV, setFilteredDPV] = useState([]);
    const [attributesList, setAttributesList] = useState([]);
    // const [selectedValue, setSelectedValue] = 0;
    // const selectorDataPointId = null;
    // const selectorDataType = null;

    function prependDataPointValueList(data) {
        data.unshift({
            id:null,
            name:""
        })};

    const fetchDataPoints = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                // setItems2(data.filter(data => data.dataPointId ==  selectedValue));
                let filtered;
                if(selectorDataPointId === 96){
                    filtered = data.filter(data => data.dataPointId ===  selectorDataPointId && data.exceptionInd === false  );}
                else {filtered = data.filter(data => data.dataPointId ===  selectorDataPointId );}
                // if(selectorDataPointId === 96){
                //     setDpvItems(data.filter(data => data.dataPointId ===  selectorDataPointId && data.exceptionInd === false  ));}
                // else {setDpvItems(data.filter(data => data.dataPointId ===  selectorDataPointId ))};
                prependDataPointValueList(filtered);
                setDpvItems(filtered);
                // setItems2(data);
                // setFilteredDPV(items2.filter(items2 => items2.dataPoint.id ==  selectedValue));
                // setFilteredDPV(items2.filter(items2 => items2.id ==  478));
                setFilteredDPV(dpvItems);
                console.log("This is my filtered data point items list...");
                console.log(dpvItems);
                console.log(filteredDPV);
            })
    useEffect(() => {
        console.log("This is for the data point value dropdown.");
        fetchDataPoints();
    }, [selectorDataPointId]);

    const fetchProductsForDropdowns = () =>
        getProductListEnhanced()
    // getAllProducts()

            .then(data => {
                console.log("Product data for dropdown");
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setProductDropdown(data);
            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdowns();
    }, [selectorDataPointId]);



    const fetchProfilesForDropdowns = () =>
        getAllProfiles()

            .then(data => {
                console.log("Profile data for dropdown");
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setProfileDropdown(data);
            })
    useEffect(() => {
        console.log("This is for the profiles dropdown...");
        fetchProfilesForDropdowns();
    }, [selectorDataPointId]);

    useEffect(() => {
        console.log("Redux selectorValue:", selectorValue);
    }, [selectorValue]);


    const fetchAttributes = () =>
        getDataPointXrefByDataPointId(selectorDataPointId)
    // getDataPointXrefByDataPointId(96)

            .then(data => {
                console.log("selectorDataPointId", selectorDataPointId);
                console.log("Attributes for Data Point");
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setAttributesList(data);
                const hasCode = data.some(item => item.attributeId === 312);

                setUseCode(hasCode);
            })
            .catch(error => console.error("xref error:", error));

    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchAttributes();
    }, [selectorDataPointId]);


    getDataPointXrefByDataPointId(selectorDataPointId)


    const fetchAttributesEnhanced = React.useCallback(() => {
        console.log("Fetching checkbox grid Data Point Values");

        return getAttributesEnhanced()

            .then(data => {
                console.log("Attribute data");
                console.log(data);
                setAttributesDropdown(
                    data.filter(item => Number(item.categoryCode) === 12020)
                );
                console.log("Attribute Data Point Values");
                console.log(data.filter(item => Number(item.categoryCode) === 12020));
                // console.log(data.filter(item => Number(item.categoryCode) === 12020));
            });
    }, [selectorDataPointId]);

    useEffect(() => {
        fetchAttributesEnhanced();
    }, [fetchAttributesEnhanced]);



    const pushValue = (newValue) => {
        if (fieldName && setValue) {
            setValue(fieldName, newValue ?? "", {
                shouldDirty: true,
                shouldValidate: true
            });
        }

        if (onChange) {
            onChange(newValue);
        }
    };

    const handleValueChange = (newValue) => {
        pushValue(newValue);

        if (onChange) {
            onChange(newValue);
        }
        console.log("handleValueChange has been triggered with this new value: ", newValue);
        // setSelectedValue(newValue);
        if(selectorContext === "WorkQueueDrawer") {
            dispatchData(changeWorkQueue({selectedCdpValue: newValue}));
            console.log("Value has been dispatched to WorkQueueDrawer.")
        }
        if(selectorContext === "WorkQueuePanel") {
            dispatchData(changeWorkQueue({topRedValue: newValue}));
            console.log("Value has been dispatched to WorkQueuePanel.")
        }
        if(selectorContext === "ContractDataPointValueFormValue") {
            dispatchData(changeContractDataPointValue({value: newValue}));
            console.log("Value has been dispatched to ContractDataPointValueFormValue.")
        }
        if(selectorContext === "ContractDataPointValueFormDefaultValue") {
            dispatchData(changeContractDataPointValue({defaultValue: newValue}));
            console.log("Default value has been dispatched to ContractDataPointValueFormDefaultValue.")
        }
        if(selectorContext === "ContractSectionFilterSingleValue") {
            dispatchData(changeContractSectionFilter({singleValue: newValue}));
            console.log("Single value has been dispatched to ContractSectionFilterSingleValue.")
        }
        if(selectorContext === "ContractSectionFilterFromValue") {
            dispatchData(changeContractSectionFilter({fromValue: newValue}));
            console.log("From value has been dispatched to ContractSectionFilterFromValue.")
        }
        if(selectorContext === "ContractSectionFilterToValue") {
            dispatchData(changeContractSectionFilter({toValue: newValue}));
            console.log("To value has been dispatched to ContractSectionFilterToValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterSingleValue") {
            dispatchData(changeContractDrilldownCDPVF({singleValue: newValue}));
            console.log("Single value has been dispatched to ContractDataPointValueFilterSingleValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterFromValue") {
            dispatchData(changeContractDrilldownCDPVF({fromValue: newValue}));
            console.log("From value has been dispatched to ContractDataPointValueFilterFromValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterToValue") {
            dispatchData(changeContractDrilldownCDPVF({toValue: newValue}));
            console.log("To value has been dispatched to ContractDataPointValueFilterToValue.")
        }
        if(selectorContext === "WorkQueueTestScenarioPeriodEnd") {
            dispatchData(changeWorkQueue({testScenarioSystemPeriod: newValue}));
            console.log("Test Scenario Period End value has been dispatched to changeWorkQueue testScenarioSystemPeriod.")
        }
        if(selectorContext === "WorkQueueTestScenarioPropertyId") {
            dispatchData(changeWorkQueue({testScenarioPropertyId: newValue}));
            console.log("Test Scenario Property ID value has been dispatched to changeWorkQueue testScenarioPropertyId.")
        }
        if(selectorContext === "label") {
            dispatchData(changeHelper({label: newValue}));
            console.log("label in Helper slice changed.")
        }
        if(selectorContext === "royalty") {
            dispatchData(changeHelper({royalty: newValue}));
            console.log("royalty in Helper slice changed.")
        }
        if(selectorContext === "min") {
            dispatchData(changeHelper({min: newValue}));
            console.log("min in Helper slice changed.")
        }
        if(selectorContext === "max") {
            dispatchData(changeHelper({max: newValue}));
            console.log("max in Helper slice changed.")
        }
        if(selectorContext === "dateFrom") {
            dispatchData(changeHelper({dateFrom: newValue}));
            console.log("dateFrom in Helper slice changed.")
        }
        if(selectorContext === "dateTo") {
            dispatchData(changeHelper({dateTo: newValue}));
            console.log("dateTo in Helper slice changed.")
        }
    };

    const handleObjectChange = (event) => {
        const newValue = event.target.value;
        pushValue(newValue);
        console.log("handleObjectChange has been triggered with this new value: ", newValue);

        if (onChange) {
            onChange(newValue);
        }

        console.log("handleObjectChange has been triggered with this new event: ", event);
        // setSelectedValue(event.target.value);
        console.log("This is for the selected Data Point Value");
        console.log(event.target.value);
        if(selectorContext === "WorkQueueDrawer") {
            dispatchData(changeWorkQueue({selectedCdpValue: event.target.value}));
            console.log("Value has been dispatched to changeWorkQueue selectedCdpValue.")
        }
        if(selectorContext === "WorkQueuePanel") {
            dispatchData(changeWorkQueue({topRedValue: event.target.value}));
            console.log("Value has been dispatched to changeWorkQueue topRedValue.")
        }
        if(selectorContext === "ContractDataPointValueFormValue") {
            dispatchData(changeContractDataPointValue({value: event.target.value}));
            console.log("Value has been dispatched to changeContractDataPointValue value.")
        }
        if(selectorContext === "ContractDataPointValueFormDefaultValue") {
            dispatchData(changeContractDataPointValue({defaultValue: event.target.value}));
            console.log("Default value has been dispatched to defaultValue defaultValue.")
        }
        if(selectorContext === "ContractSectionFilterSingleValue") {
            dispatchData(changeContractSectionFilter({singleValue: event.target.value}));
            console.log("Single value has been dispatched to changeContractSectionFilter singleValue.")
        }
        if(selectorContext === "ContractSectionFilterFromValue") {
            dispatchData(changeContractSectionFilter({fromValue: event.target.value}));
            console.log("From value has been dispatched to changeContractSectionFilter fromValue.")
        }
        if(selectorContext === "ContractSectionFilterToValue") {
            dispatchData(changeContractSectionFilter({toValue: event.target.value}));
            console.log("To value has been dispatched to changeContractSectionFilter toValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterSingleValue") {
            dispatchData(changeContractDrilldownCDPVF({singleValue: event.target.value}));
            console.log("Single value has been dispatched to changeContractDrilldownCDPVF singleValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterFromValue") {
            dispatchData(changeContractDrilldownCDPVF({fromValue: event.target.value}));
            console.log("From value has been dispatched to changeContractDrilldownCDPVF fromValue.")
        }
        if(selectorContext === "ContractDataPointValueFilterToValue") {
            dispatchData(changeContractDrilldownCDPVF({toValue: event.target.value}));
            console.log("To value has been dispatched to changeContractDrilldownCDPVF toValue.")
        }
        if(selectorContext === "WorkQueueTestScenarioPeriodEnd") {
            dispatchData(changeWorkQueue({testScenarioSystemPeriod: event.target.value}));
            console.log("Test Scenario Period End value has been dispatched to changeWorkQueue testScenarioSystemPeriod.")
        }
        if(selectorContext === "WorkQueueTestScenarioPropertyId") {
            dispatchData(changeWorkQueue({testScenarioPropertyId: event.target.value}));
            console.log("Test Scenario Property ID value has been dispatched to changeWorkQueue testScenarioPropertyId.")
        }
        if(selectorContext === "label") {
            dispatchData(changeHelper({label: event.target.value}));
            console.log("label in Helper slice changed.")
        }
        if(selectorContext === "royalty") {
            dispatchData(changeHelper({royalty: event.target.value}));
            console.log("royalty in Helper slice changed.")
        }
        if(selectorContext === "min") {
            dispatchData(changeHelper({min: event.target.value}));
            console.log("min in Helper slice changed.")
        }
        if(selectorContext === "max") {
            dispatchData(changeHelper({max: event.target.value}));
            console.log("max in Helper slice changed.")
        }
        if(selectorContext === "dateFrom") {
            dispatchData(changeHelper({dateFrom: event.target.value}));
            console.log("dateFrom in Helper slice changed.")
        }
        if(selectorContext === "dateTo") {
            dispatchData(changeHelper({dateTo: event.target.value}));
            console.log("dateTo in Helper slice changed.")
        }

    };

    const [internalValue, setInternalValue] = useState(selectorValue);


    useEffect(() => {
        setInternalValue(selectorValue);
    }, [selectorValue]);





    return(
        <Box>
            {(
                selectorDataPointId !== 71 && selectorDataPointId !== 11997 && selectorDataPointId !== 530 && selectorDataPointId !== 74 && selectorDataPointId !== 532
                    &&  selectorDataPointId !== 3557 &&  selectorDataPointId !== 3558 &&  selectorDataPointId !== 532
                    && selectorDataPointId !== 11612  && selectorDataPointId !== 11614  &&  selectorDataPointId !== 12410 &&  selectorDataPointId !== 12738
                // && useCode !== true
                ) &&
                <div>
                                 {
                        (selectorDataType === 'CODE' ||
                            selectorDataType === 'YES_NO' ||
                            selectorDataType === 'REFERENCE') &&
                        <FormControl variant="standard"
                            // sx={{ m: 1, minWidth: 120 }}
                                     sx={{width: 350}}
                        >
                            {/*<br/>*/}
                            {/*<br/>*/}
                            {/*<br/>*/}
                            <InputLabel id="demo-simple-select-label2"
                                        shrink={!!selectorValue} // Shrink label when there is a value
                            >{selectorLabel}</InputLabel>
                            <Select
                                variant="standard"
                                labelId="demo-simple-select-filled-label2"
                                id="value2"
                                // value={selectedValue2}
                                // defaultValue = {selectorValue}
                                value = {Number(selectorValue)}
                                label="Data Point Value"
                                // onChange={(ev) => setItems(ev.target.value)}
                                onChange={handleObjectChange}
                                autoFocus={autoFocus}
                            >
                                {/*<MenuItem value="">*/}
                                {/*    <em>None</em>*/}
                                {/*</MenuItem>*/}
                                {dpvItems.map((dpvItem) =>
                                    <MenuItem value={dpvItem.id}>{dpvItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>}



                    {
                    (selectorDataType === 'GROUP') &&
                    <FormControl variant="standard"
                        // sx={{ m: 1, minWidth: 120 }}
                                 sx={{width: 350}}
                    >
                        {/*<br/>*/}
                        {/*<br/>*/}
                        {/*<br/>*/}
                        <InputLabel id="demo-simple-select-label2"
                                    shrink={!!selectorValue} // Shrink label when there is a value
                        >{selectorLabel}</InputLabel>
                        <Select
                            variant="standard"
                            labelId="demo-simple-select-filled-label2"
                            id="value2"
                            // value={selectedValue2}
                            // defaultValue = {selectorValue}
                            value = {Number(selectorValue)}
                            label="Data Point Value"
                            // onChange={(ev) => setItems(ev.target.value)}
                            onChange={handleObjectChange}
                            autoFocus={autoFocus}
                        >
                            {/*<MenuItem value="">*/}
                            {/*    <em>None</em>*/}
                            {/*</MenuItem>*/}
                            {attributesDropdown.map((attributesDropdown) =>
                                <MenuItem value={attributesDropdown.id}>{attributesDropdown.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>}


                    {/*<DataPointValueDDL/>*/}
                    {/*<DataPointValueDDL/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*{If(selectorDataType === 'CODE'){false}{true} &&*/}
                    {
                        (selectorDataType !== 'CODE' &&
                            selectorDataType !== 'YES_NO' &&
                            selectorDataType !== 'REFERENCE' &&
                            selectorDataType !== 'DATE' &&
                            selectorDataType !== 'DOLLARS' &&
                            selectorDataType !== 'PERCENTAGE' &&
                            selectorDataType !== 'GROUP'
                        ) &&
                        <FormControl
                            // fullWidth
                            sx={{width: 300}}
                        >
                            <TextField id="value2" label={selectorLabel}
                                       // defaultValue={selectorValue}
                                       value={selectorValue ?? ""}
                                // value={selectedValue}
                                       variant='standard'
                                       onChange={handleObjectChange}
                                       autoFocus={autoFocus}
                                       InputLabelProps={{
                                           shrink: true
                                           // shrink: Boolean(selectorValue)
                                           // shrink: !!selectedValue || false, // Force shrink if value exists, otherwise control shrink
                                       }}
                            />
                        </FormControl>}
                    {
                        (selectorDataType === 'DOLLARS'
                        ) &&
                        <FormControl sx={{ width: 130 }}>
                            <NumericFormat
                                customInput={TextField}
                                label={selectorLabel}
                                value={selectorValue ?? ""}
                                variant='standard'
                                onValueChange={(values) => {
                                    handleValueChange(values.floatValue); // This gives you the raw number (e.g., 1234.56)
                                }}
                                thousandSeparator=","
                                decimalScale={2}
                                fixedDecimalScale
                                autoFocus={autoFocus}
                                prefix="$"
                                allowNegative={true}
                                // InputLabelProps={{
                                //     shrink: selectorValue !== null && selectorValue !== undefined && selectorValue !== '',
                                // }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                // InputLabelProps={{
                                //     shrink: Boolean(selectorValue),
                                // }}
                            />
                        </FormControl>
                    }
                    {
                        (selectorDataType === 'PERCENTAGE'
                        ) &&
                        <FormControl sx={{ width: 100 }}>
                            <NumericFormat
                                customInput={TextField}
                                label={selectorLabel}
                                variant='standard'
                                // value={selectorValue != null ? selectorValue * 100 : ''}
                                value={selectorValue !== null && selectorValue !== undefined && selectorValue !== '' ? parseFloat(selectorValue) * 100 : ''}

                                // onValueChange={(values) => {
                                //     const raw = values.floatValue;
                                //     handleValueChange(raw != null ? raw / 100 : null); // Convert back to decimal
                                // }}
                                onValueChange={(values) => {
                                    const raw = values.floatValue;
                                    console.log("value change triggered for percentage");
                                    console.log("raw = ", raw);
                                    if (raw === 0) {
                                        handleValueChange("0.00");  // ✅ Explicitly send 0 as a string
                                    } else if (raw != null) {
                                        handleValueChange((raw / 100).toFixed(6));  // ✅ Always a string with 2 decimal places
                                    } else {
                                        handleValueChange(null);  // blank input
                                    }
                                }}
                                suffix="%"
                                decimalScale={2}
                                decimalSeparator="."
                                fixedDecimalScale
                                allowNegative={true}
                                allowZero={true}
                                autoFocus={autoFocus}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                    }
                    {selectorDataType === 'DATE' &&
                        <DynamicDatePicker
                            selectorLabel={selectorLabel}
                            selectorValue={selectorValue}
                            handleValueChange={handleValueChange}
                            autoFocus={autoFocus}
                            disabled={disabled}
                        />
                    }
                </div>
            }

            {((selectorDataPointId === 71 || selectorDataPointId === 11997  )  &&
                (selectorContext === "ContractDataPointValueFilterToValue" ||
                    selectorContext === "ContractDataPointValueFilterFromValue" ||
                    selectorContext === "ContractSectionFilterFromValue" ||
                    selectorContext === "ContractSectionFilterToValue"))
                &&
                <FormControl
                    // fullWidth
                    sx={{width: 300}}
                >
                    <TextField id="value2" label={selectorLabel} variant="standard"
                               defaultValue={selectorValue}
                        // value={selectedValue}
                               onChange={handleObjectChange}
                               autoFocus={autoFocus}
                               InputLabelProps={{
                                   shrink: Boolean(selectorValue)
                                   // shrink: !!selectedValue || false, // Force shrink if value exists, otherwise control shrink
                               }}
                    />
                </FormControl>}


            {((selectorDataPointId === 71   || selectorDataPointId === 11997   || selectorDataPointId === 11612  || selectorDataPointId === 11614)  &&
                    selectorContext !== "ContractDataPointValueFilterToValue" &&
                    selectorContext !== "ContractDataPointValueFilterFromValue" &&
                    selectorContext !== "ContractSectionFilterFromValue" &&
                    selectorContext !== "ContractSectionFilterToValue")
                &&
                <Box>
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <Tooltip enterDelay={1000} enterNextDelay={1000}
                    //              title={<span style={{whiteSpace: 'pre-line'}}>
                    // {"Guilds present : " + contracts.row.id +
                    //     "\nGuilds present : " + contracts.row.mcode
                    // }</span>}
                                 title="Select the property related to this contract.">
                            <InputLabel shrink={!!selectorValue}>{selectorLabel}</InputLabel>
                        </Tooltip>

                        <Autocomplete
                            id="value2"
                            disablePortal
                            disableCloseOnBlur
                            options={productDropdown}
                            autoFocus={autoFocus}
                            ListboxProps={{
                                style: {
                                    maxHeight: 400,  // <-- make the listbox longer
                                },
                                onClick: (event) => {
                                    event.stopPropagation();
                                }
                            }}
                            // getOptionLabel={(option) => `${option.seasonName} ${option.name} (${option.id}) option?.guildNameList ? ${option.guildNameList} : "" `}
                            getOptionLabel={(o) => [
                                o?.seasonName || "",
                                o?.name || "",
                                (o?.id ?? null) !== null ? `(${o.id})` : "",
                                o?.guildNameList ? `[${o.guildNameList}]` : ""
                            ].filter(Boolean).join(" ")}
                            // value={productDropdown.length > 0 ? productDropdown.find(item => item.id === selectedValue2) || null : null}
                            value={productDropdown.length > 0
                                ? productDropdown.find(item => Number(item.id) === Number(selectorValue)) || null
                                : null}
                            // value={productDropdown.find(item => item.id === selectedValue2) || null}
                            onChange={(event, newValue) => {
                                handleValueChange(newValue ? newValue.id : null);
                            }}
                            disabled={disabled}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={selectorLabel}
                                    variant="standard"
                                    disabled={disabled}
                                />
                            )}
                            sx={{ width:600 }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </FormControl>

                </Box>}


            {(selectorDataPointId === 530 || selectorDataPointId === 74 || selectorDataPointId === 532
                    ||  selectorDataPointId === 3557 ||  selectorDataPointId === 3558 ||  selectorDataPointId === 532
                    ||  selectorDataPointId === 12410 ||  selectorDataPointId === 12738

                ) &&
                <Box>
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}

                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <Tooltip enterDelay={1000} enterNextDelay={1000} title="Select the profile from the list.">
                            <InputLabel shrink={!!selectorValue}>{selectorLabel}</InputLabel>
                        </Tooltip>

                        <Autocomplete
                            id="value2"
                            disablePortal
                            disableCloseOnBlur
                            options={profileDropdown}
                            autoFocus={autoFocus}
                            ListboxProps={{
                                style: {
                                    maxHeight: 400,  // make the listbox longer
                                },
                                onClick: (event) => {
                                    event.stopPropagation();
                                }
                            }}
                            // getOptionLabel={(option) => `${option.lastName}, ${option.firstName} ${option.companyName} (${option.id})`}
                            getOptionLabel={(option) => {
                                if (!option) return '';

                                const nameParts = [];
                                if (option.lastName) nameParts.push(option.lastName);
                                if (option.firstName) nameParts.push(option.firstName);
                                const nameString = nameParts.join(', ');

                                // return `${nameString} ${(option.companyName !== null && option.companyName !== undefined ? ' - ' +  option.companyName : '')} (${option.id})`.trim();
                                return `${nameString}${nameString && option.companyName ? ' - ' : ' '}${option.companyName ?? ''} (${option.id})`.trim();
                            }}

                            value={profileDropdown.length > 0
                                ? profileDropdown.find(item => Number(item.id) === Number(selectorValue)) || null
                                : null
                            }
                            onChange={(event, newValue) => {
                                handleValueChange(newValue ? newValue.id : null);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={selectorLabel}
                                    variant="standard"
                                />
                            )}
                            sx={{ width: 350 }}
                            isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                        />
                    </FormControl>

                </Box>}
        </Box>
    )


}